import { useState } from 'react';
import { Link } from 'react-router-dom';
import { registerMandal } from '../services/api';
import CustomSelect from '../components/CustomSelect';
import './Register.css';

const areas = ['Valsad City', 'Bulsar', 'Pardi', 'Vapi', 'Umargam', 'Dharampur', 'Kaprada', 'Navsari', 'Bilimora', 'Gandevi', 'Other'];
const activities = [
  { name: 'Cultural Events', desc: 'Festivals, cultural programs & performances that celebrate our traditions.' },
  { name: 'Blood Donation', desc: 'Voluntary blood donation camps to help save lives in the community.' },
  { name: 'Medical Camp', desc: 'Free health check-ups and medical assistance for the underprivileged.' },
  { name: 'Food Distribution', desc: 'Distributing meals and ration kits to those in need.' },
  { name: 'Tree Plantation', desc: 'Planting trees to protect the environment and increase green cover.' },
  { name: 'Cleanliness Drive', desc: 'Community clean-up drives for a cleaner, healthier neighbourhood.' },
  { name: 'Scholarship', desc: 'Financial support and study materials for deserving students.' },
  { name: 'Air Pollution Reduction', desc: 'Using eco-friendly practices and materials to reduce air pollution during celebrations.' },
  { name: 'Plastic Free Festival', desc: 'Eliminating single-use plastic across pandal, prasad and decorations.' },
  { name: 'Save Water & Water Pollution', desc: 'Conserving water and preventing pollution of rivers, ponds and water bodies.' },
  { name: 'Digital Awareness', desc: 'Educating the community on safe and responsible use of digital technology.' },
  { name: 'Mental Health / Suicide Prevention Awareness', desc: 'Spreading awareness and support for mental well-being and suicide prevention.' },
  { name: 'Gau Seva', desc: 'Care and service towards cows, including feeding and shelter support.' },
  { name: 'Educational Support', desc: 'Helping students with tuition, books and learning resources.' },
  { name: 'Other', desc: 'Any other social or community activity your mandal conducts.' },
];

const steps = ['Mandal Info', 'Contact Details', 'Activities', 'Submit'];

export default function Register() {
  const [quizPassed, setQuizPassed] = useState(false);
  const [quizAnswers, setQuizAnswers] = useState({ q1: '', q2: '' });
  const [quizError, setQuizError] = useState('');
  const [step, setStep] = useState(0);
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const [setPasswordNow, setSetPasswordNow] = useState(false);
  const [form, setForm] = useState({
    santhaName: '',
    yearEstd: '',
    area: '',
    address: '',
    memberCount: '',
    idolDuration: '',
    contactName: '',
    contactEmail: '',
    contactPhone: '',
    whatsapp: '',
    altContactName: '',
    altContactPhone: '',
    selectedActivities: [],
    otherActivityText: '',
    description: '',
    panNumber: '',
    password: '',
    agreed: false,
  });

  const update = (field, value) => setForm((f) => ({ ...f, [field]: value }));
  const toggleActivity = (act) => {
    update('selectedActivities',
      form.selectedActivities.includes(act)
        ? form.selectedActivities.filter((a) => a !== act)
        : [...form.selectedActivities, act]
    );
  };

  const handleQuizSubmit = (e) => {
    e.preventDefault();
    if (quizAnswers.q1 === 'A' && quizAnswers.q2 === 'A') {
      setQuizError('');
      setQuizPassed(true);
    } else {
      setQuizError("That's not quite right — please review both questions and try again.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitError(null);
    setSubmitting(true);
    try {
      const activities = form.selectedActivities.includes('Other') && form.otherActivityText.trim()
        ? form.selectedActivities.map((a) => (a === 'Other' ? `Other: ${form.otherActivityText.trim()}` : a))
        : form.selectedActivities;
      await registerMandal({
        name: form.santhaName,
        area: form.area,
        yearEstd: Number(form.yearEstd),
        address: form.address || undefined,
        memberCount: Number(form.memberCount),
        idolDuration: Number(form.idolDuration),
        contactName: form.contactName,
        contactEmail: form.contactEmail,
        contactPhone: form.contactPhone,
        whatsapp: form.whatsapp || undefined,
        altContactName: form.altContactName || undefined,
        altContactPhone: form.altContactPhone || undefined,
        activities,
        description: form.description || undefined,
        panNumber: form.panNumber || undefined,
        password: setPasswordNow && form.password ? form.password : undefined,
      });
      setSubmitted(true);
    } catch (err) {
      setSubmitError(err?.response?.data?.error || 'Something went wrong while submitting your registration. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (submitted) {
    return (
      <div className="register-page">
        <div className="page-hero">
          <div className="container">
            <div className="badge">Registration</div>
            <h1>Register Your Mandal</h1>
          </div>
        </div>
        <section>
          <div className="container" style={{ maxWidth: 600, textAlign: 'center' }}>
            <div className="success-card card">
              <div style={{ fontSize: '4rem' }}>✅</div>
              <h2>Registration Successful!</h2>
              <p>Thank you for joining the Purposeful Ganesh Mahotsav Movement.</p>
              <p>Let's celebrate with devotion, serve society, and protect nature.</p>
              <p style={{ fontWeight: 600, color: 'var(--gold-dark)' }}>गणपती बाप्पा मोरया!</p>
              <p style={{ marginTop: 16 }}>Our team will review <strong>{form.santhaName}</strong>'s details within 2–3 working days.</p>
              <p>📧 We've sent a confirmation email to <strong>{form.contactEmail}</strong> — {setPasswordNow && form.password
                ? 'click the link inside to verify your address and unlock your mandal portal login.'
                : 'click the link inside to set your password and unlock your mandal portal login.'}</p>
              <button className="btn-primary" style={{ marginTop: 24 }} onClick={() => { setSubmitted(false); setStep(0); }}>
                Register Another Mandal
              </button>
            </div>
          </div>
        </section>
      </div>
    );
  }

  if (!quizPassed) {
    return (
      <div className="register-page">
        <div className="page-hero">
          <div className="container">
            <div className="badge">Before You Begin</div>
            <h1>A Quick Question</h1>
            <p>Two quick questions about the spirit of Sarvajanik Ganesh Mahotsav before you register your mandal.</p>
          </div>
        </div>
        <section>
          <div className="container" style={{ maxWidth: 700 }}>
            <form className="register-form card" onSubmit={handleQuizSubmit}>
              <div className="form-step">
                <h2>Question 1 / प्रश्न 1</h2>
                <p style={{ color: 'var(--text-mid)', marginBottom: 2 }}>Who revolutionized the Sarvajanik Ganesh Mahotsav?</p>
                <p style={{ color: 'var(--text-light)', fontSize: '0.85rem', marginBottom: 14 }}>सार्वजनिक गणेश महोत्सव को जनआंदोलन का स्वरूप किसने प्रदान किया?</p>
                <div className="field-group" style={{ gap: 10 }}>
                  <label className={`activity-check${quizAnswers.q1 === 'A' ? ' checked' : ''}`}>
                    <input type="radio" name="q1" checked={quizAnswers.q1 === 'A'} onChange={() => setQuizAnswers((a) => ({ ...a, q1: 'A' }))} />
                    Lokmanya Bal Gangadhar Tilak / लोकमान्य बाल गंगाधर तिलक
                  </label>
                  <label className={`activity-check${quizAnswers.q1 === 'B' ? ' checked' : ''}`}>
                    <input type="radio" name="q1" checked={quizAnswers.q1 === 'B'} onChange={() => setQuizAnswers((a) => ({ ...a, q1: 'B' }))} />
                    Mahatma Gandhi / महात्मा गांधी
                  </label>
                </div>

                <h2 style={{ marginTop: 28 }}>Question 2 / प्रश्न 2</h2>
                <p style={{ color: 'var(--text-mid)', marginBottom: 2 }}>What is the primary purpose of the Sarvajanik Ganesh Mahotsav?</p>
                <p style={{ color: 'var(--text-light)', fontSize: '0.85rem', marginBottom: 14 }}>सार्वजनिक गणेश महोत्सव का मुख्य उद्देश्य क्या है?</p>
                <div className="field-group" style={{ gap: 10 }}>
                  <label className={`activity-check${quizAnswers.q2 === 'A' ? ' checked' : ''}`}>
                    <input type="radio" name="q2" checked={quizAnswers.q2 === 'A'} onChange={() => setQuizAnswers((a) => ({ ...a, q2: 'A' }))} />
                    National unity and community welfare / राष्ट्रीय एकता एवं समाज कल्याण
                  </label>
                  <label className={`activity-check${quizAnswers.q2 === 'B' ? ' checked' : ''}`}>
                    <input type="radio" name="q2" checked={quizAnswers.q2 === 'B'} onChange={() => setQuizAnswers((a) => ({ ...a, q2: 'B' }))} />
                    Religious worship and festive celebrations / धार्मिक पूजा-अर्चना एवं उत्सव मनाना
                  </label>
                </div>

                {quizError && <p style={{ color: '#c0392b', fontSize: '0.9rem', marginTop: 16 }}>{quizError}</p>}

                <div className="step-nav">
                  <div />
                  <button type="submit" className="btn-primary" disabled={!quizAnswers.q1 || !quizAnswers.q2}>Continue →</button>
                </div>
              </div>
            </form>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="register-page">
      <div className="page-hero">
        <div className="container">
          <div className="badge">Join Us</div>
          <h1>Register Your Mandal</h1>
          <p>Get your Ganpati Mahotsav Mandal listed on Aarambh's directory — reach more devotees, receive donations and coordinate activities.</p>
        </div>
      </div>

      <section>
        <div className="container register-layout">
          <div className="register-main">
            {/* Stepper */}
            <div className="stepper">
              {steps.map((s, i) => (
                <div key={s} className={`step${i === step ? ' active' : i < step ? ' done' : ''}`}>
                  <div className="step-circle">{i < step ? '✓' : i + 1}</div>
                  <span className="step-label">{s}</span>
                  {i < steps.length - 1 && <div className="step-line" />}
                </div>
              ))}
            </div>

            <form className="register-form card" onSubmit={handleSubmit}>
              {/* Step 0 */}
              {step === 0 && (
                <div className="form-step">
                  <h2>Mandal Information</h2>
                  <div className="field-group">
                    <label>Mandal Name *</label>
                    <input className="form-input" placeholder="e.g. Shri Siddhivinayak Ganesh Utsav Mandal" value={form.santhaName} onChange={(e) => update('santhaName', e.target.value)} required />
                  </div>
                  <div className="field-row">
                    <div className="field-group">
                      <label>Year Established *</label>
                      <input className="form-input" type="number" placeholder="e.g. 2010" min="1950" max="2025" value={form.yearEstd} onChange={(e) => update('yearEstd', e.target.value)} required />
                    </div>
                    <div className="field-group">
                      <label>Number of Members *</label>
                      <input className="form-input" type="number" placeholder="e.g. 80" min="5" value={form.memberCount} onChange={(e) => update('memberCount', e.target.value)} required />
                    </div>
                  </div>
                  <div className="field-group">
                    <label>Area / Taluka *</label>
                    <CustomSelect options={areas} value={form.area} onChange={(v) => update('area', v)} placeholder="Select Area" />
                  </div>
                  <div className="field-group">
                    <label>Ganesh Idol Installation Duration (days) *</label>
                    <input className="form-input" type="number" placeholder="e.g. 5" min="1" max="30" value={form.idolDuration} onChange={(e) => update('idolDuration', e.target.value)} required />
                    <p style={{ fontSize: '0.8rem', color: 'var(--text-light)' }}>
                      Number of days for which the Ganesh idol will be installed and worshipped by your mandal (e.g. 3, 5, 7, 10 days).
                    </p>
                  </div>
                  <div className="field-group">
                    <label>Full Address</label>
                    <textarea className="form-input" rows={3} placeholder="Street, landmark, village/city, pincode" value={form.address} onChange={(e) => update('address', e.target.value)} />
                  </div>
                  <div className="step-nav">
                    <div />
                    <button type="button" className="btn-primary" onClick={() => setStep(1)}>Next →</button>
                  </div>
                </div>
              )}

              {/* Step 1 */}
              {step === 1 && (
                <div className="form-step">
                  <h2>Contact Details</h2>
                  <div className="field-group">
                    <label>Primary Contact Name *</label>
                    <input className="form-input" placeholder="Full name of President / Secretary" value={form.contactName} onChange={(e) => update('contactName', e.target.value)} required />
                  </div>
                  <div className="field-row">
                    <div className="field-group">
                      <label>Email Address *</label>
                      <input className="form-input" type="email" placeholder="contact@example.com" value={form.contactEmail} onChange={(e) => update('contactEmail', e.target.value)} required />
                    </div>
                    <div className="field-group">
                      <label>Phone Number *</label>
                      <input className="form-input" type="tel" placeholder="+91 99999 00000" value={form.contactPhone} onChange={(e) => update('contactPhone', e.target.value)} required />
                    </div>
                  </div>
                  <div className="field-group">
                    <label>WhatsApp Group Link (optional)</label>
                    <input className="form-input" placeholder="https://chat.whatsapp.com/..." value={form.whatsapp} onChange={(e) => update('whatsapp', e.target.value)} />
                  </div>
                  <div className="field-row">
                    <div className="field-group">
                      <label>Alternate Contact Person (optional)</label>
                      <input className="form-input" placeholder="Name of a second point of contact" value={form.altContactName} onChange={(e) => update('altContactName', e.target.value)} />
                    </div>
                    <div className="field-group">
                      <label>Alternate Contact Phone (optional)</label>
                      <input className="form-input" type="tel" placeholder="+91 99999 00000" value={form.altContactPhone} onChange={(e) => update('altContactPhone', e.target.value)} />
                    </div>
                  </div>
                  <div className="step-nav">
                    <button type="button" className="btn-outline" onClick={() => setStep(0)}>← Back</button>
                    <button type="button" className="btn-primary" onClick={() => setStep(2)}>Next →</button>
                  </div>
                </div>
              )}

              {/* Step 2 */}
              {step === 2 && (
                <div className="form-step">
                  <h2>Activities & Description</h2>
                  <div className="field-group">
                    <label>Social Activities Conducted (select all that apply)</label>
                    <div className="activities-grid">
                      {activities.map((act) => (
                        <label key={act.name} className={`activity-check${form.selectedActivities.includes(act.name) ? ' checked' : ''}`}>
                          <input type="checkbox" checked={form.selectedActivities.includes(act.name)} onChange={() => toggleActivity(act.name)} />
                          <span className="activity-check-text">
                            <span className="activity-check-title">{act.name}</span>
                            <span className="activity-check-desc">{act.desc}</span>
                          </span>
                        </label>
                      ))}
                    </div>
                    <p style={{ fontSize: '0.8rem', color: 'var(--text-light)', marginTop: 8 }}>
                      Select every social activity your mandal regularly conducts — this helps devotees and volunteers find and support you for the right causes.
                    </p>
                    <p style={{ fontSize: '0.8rem', color: 'var(--gold-dark)', fontWeight: 500, marginTop: 8 }}>
                      Note: All social, environmental, and community welfare activities shall be undertaken voluntarily and in compliance with all applicable Government rules, regulations, guidelines, and permissions.
                    </p>
                    {form.selectedActivities.includes('Other') && (
                      <input
                        className="form-input"
                        style={{ marginTop: 10 }}
                        placeholder="Please specify the other activity"
                        value={form.otherActivityText}
                        onChange={(e) => update('otherActivityText', e.target.value)}
                      />
                    )}
                  </div>
                  <div className="field-group">
                    <label>About Your Mandal</label>
                    <textarea className="form-input" rows={4} placeholder="Tell us about your mandal — history, achievements, what makes you unique..." value={form.description} onChange={(e) => update('description', e.target.value)} />
                  </div>
                  <div className="field-group">
                    <label>PAN Number (if applicable)</label>
                    <input className="form-input" placeholder="e.g. AAAPL1234C" value={form.panNumber} onChange={(e) => update('panNumber', e.target.value)} />
                  </div>
                  <div className="step-nav">
                    <button type="button" className="btn-outline" onClick={() => setStep(1)}>← Back</button>
                    <button type="button" className="btn-primary" onClick={() => setStep(3)}>Next →</button>
                  </div>
                </div>
              )}

              {/* Step 3 */}
              {step === 3 && (
                <div className="form-step">
                  <h2>Review & Submit</h2>
                  <div className="review-grid">
                    <div className="review-item">
                      <span className="review-label">Mandal Name</span>
                      <span className="review-value">{form.santhaName || '—'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Area</span>
                      <span className="review-value">{form.area || '—'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Established</span>
                      <span className="review-value">{form.yearEstd || '—'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Members</span>
                      <span className="review-value">{form.memberCount || '—'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Idol Duration</span>
                      <span className="review-value">{form.idolDuration ? `${form.idolDuration} days` : '—'}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Contact</span>
                      <span className="review-value">{form.contactName} — {form.contactEmail}</span>
                    </div>
                    <div className="review-item">
                      <span className="review-label">Phone</span>
                      <span className="review-value">{form.contactPhone || '—'}</span>
                    </div>
                    <div className="review-item" style={{ gridColumn: '1 / -1' }}>
                      <span className="review-label">Activities</span>
                      <span className="review-value">{form.selectedActivities.join(', ') || 'None selected'}</span>
                    </div>
                  </div>

                  <p style={{
                    fontStyle: 'italic',
                    color: 'var(--gold-dark)',
                    fontSize: '0.92rem',
                    lineHeight: 1.7,
                    borderLeft: '3px solid var(--gold)',
                    padding: '4px 16px',
                    margin: '4px 0 24px',
                  }}>
                    "Your registration is not just an entry—it is a commitment towards a cleaner environment, stronger society, and a more purposeful Sarvajanik Ganesh Mahotsav."
                  </p>

                  <div className="field-group">
                    <label className="activity-check" style={{ marginBottom: 8 }}>
                      <input type="checkbox" checked={setPasswordNow} onChange={(e) => setSetPasswordNow(e.target.checked)} />
                      Set my portal login password now
                    </label>
                    <p style={{ color: 'var(--text-light)', fontSize: '0.85rem', marginBottom: 10 }}>
                      Your username will be your email address: <strong style={{ color: 'var(--gold-dark)' }}>{form.contactEmail || '—'}</strong>
                    </p>
                    {setPasswordNow ? (
                      <input
                        className="form-input"
                        type="password"
                        placeholder="Choose a password (min. 8 characters)"
                        minLength={8}
                        value={form.password}
                        onChange={(e) => update('password', e.target.value)}
                        required={setPasswordNow}
                      />
                    ) : (
                      <p style={{ color: 'var(--text-light)', fontSize: '0.85rem' }}>
                        You'll get a link in your confirmation email to set your password instead.
                      </p>
                    )}
                  </div>

                  <label className="agree-check">
                    <input type="checkbox" checked={form.agreed} onChange={(e) => update('agreed', e.target.checked)} required />
                    <span>
                      I certify that the information provided is accurate and I agree to Aarambh's{' '}
                      <Link to="/terms-and-conditions" target="_blank" rel="noopener noreferrer">Terms & Conditions</Link>
                      {' '}and{' '}
                      <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</Link>.
                    </span>
                  </label>

                  {submitError && (
                    <p style={{ color: '#c0392b', fontSize: '0.9rem', marginTop: 8 }}>{submitError}</p>
                  )}

                  <div className="step-nav">
                    <button type="button" className="btn-outline" onClick={() => setStep(2)}>← Back</button>
                    <button type="submit" className="btn-primary" disabled={!form.agreed || submitting}>
                      {submitting ? 'Submitting...' : 'Submit Registration'}
                    </button>
                  </div>
                </div>
              )}
            </form>
          </div>

          {/* Side Info */}
          <div className="register-sidebar">
            <div className="benefits-card card">
              <h3>Benefits of Registering</h3>
              <ul className="benefits-list">
                {[
                  "Listed in Valsad's Mandal Directory",
                  'Receive online donations directly',
                  'Co-ordinate with 50+ other mandal',
                  'Promote your events to devotees',
                  'Access volunteer network',
                  'Feature in Aarambh social media',
                  '100% Free — no charges ever',
                ].map((benefit) => (
                  <li key={benefit}>
                    <svg
                      className="benefit-icon"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fillRule="evenodd"
                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                        clipRule="evenodd"
                      />
                    </svg>
                    <span>{benefit}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="register-note card">
              <h3>📋 What you'll need</h3>
              <ul>
                <li>Mandal name and founding year</li>
                <li>Contact person details</li>
                <li>List of activities you conduct</li>
                <li>PAN / registration number (optional)</li>
              </ul>
              <p style={{ fontSize: '0.82rem', color: 'var(--text-light)', marginTop: 12 }}>
                Registration is reviewed and approved within 2–3 working days.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
